import { render, staticRenderFns } from "./PlanQuotaItems.vue?vue&type=template&id=239decc0&scoped=true&"
import script from "./PlanQuotaItems.vue?vue&type=script&lang=js&"
export * from "./PlanQuotaItems.vue?vue&type=script&lang=js&"
import style0 from "./PlanQuotaItems.vue?vue&type=style&index=0&id=239decc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239decc0",
  null
  
)

export default component.exports